import { Service } from "../interfaces/service";
import { fetchWithAuth } from "./fetchWithAuth";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_API_URL
      : DEV_API_URL;

export const getAllServices = async (): Promise<Service[]> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const response = await fetch(`${apiBaseUrl}/api/Service/GetServices`);

  if (!response.ok) {
    throw new Error("Failed to fetch services");
  }

  const services: Service[] = await response.json();
  return services;
};

export const getAllAllServices = async (): Promise<Service[]> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const response = await fetch(`${apiBaseUrl}/api/Service/GetAllServices`);

  if (!response.ok) {
    throw new Error("Failed to fetch services");
  }

  const services: Service[] = await response.json();
  return services;
};

export const updateService = async (service: Service): Promise<Service> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/Service/UpdateService`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(service),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to update service");
  }

  const serviceResponse: Service = await response.json();
  return serviceResponse;
};

export const createService = async (service: Service): Promise<Service> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/Service/CreateService`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(service),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to create service");
  }

  const serviceResponse: Service = await response.json();
  return serviceResponse;
};

export const deleteService = async (serviceID: number): Promise<void> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/Service/DeleteService/${serviceID}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to delete service`);
  }
};
